import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

export const useGoBack = () => {
  const navigate = useNavigate()

  return () => {
    navigate(PATHS.yard.planningDashboard.url)
  }
}
